export default __webpack_public_path__ + "static/ira-a6db0f09d8c14693c5f73dcff15b70fa.webp";